import { PaletteOptions } from '@mui/material/styles';

// テーマ1: プロフェッショナル - ダークブルー系ビジネス向けパレット
export const palette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#1e3c72',
    light: '#2a5298',
    dark: '#152a52',
    contrastText: '#ffffff'
  },
  secondary: {
    main: '#2a5298',
    light: '#3d6bb3',
    dark: '#1e3c72',
    contrastText: '#ffffff'
  },
  success: {
    main: '#4CAF50',
    light: '#81C784',
    dark: '#388E3C',
    contrastText: '#ffffff'
  },
  error: {
    main: '#f44336',
    light: '#e57373',
    dark: '#d32f2f',
    contrastText: '#ffffff'
  },
  warning: {
    main: '#ff9800',
    light: '#ffb74d',
    dark: '#f57c00',
    contrastText: 'rgba(0, 0, 0, 0.87)'
  },
  info: {
    main: '#2196f3',
    light: '#64b5f6',
    dark: '#1976d2',
    contrastText: '#ffffff'
  },
  background: {
    default: '#f5f7fa',
    paper: '#ffffff'
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.6)',
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  divider: 'rgba(0, 0, 0, 0.12)'
};
